// Pure helpers for the Trash takeover view.
//
// No DOM, no React, no fetch. The TrashView component composes these with
// state hooks and ReactDOM.

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function groupByFolder(items) {
  if (!items || items.length === 0) return [];
  const byFolder = new Map();
  for (const f of items) {
    const i = f.path.lastIndexOf('/');
    const folder = i < 0 ? '' : f.path.slice(0, i);
    const name = i < 0 ? f.path : f.path.slice(i + 1);
    if (!byFolder.has(folder)) byFolder.set(folder, []);
    byFolder.get(folder).push({ ...f, name });
  }
  const folders = [...byFolder.keys()].sort((a, b) =>
    a < b ? -1 : a > b ? 1 : 0,
  );
  return folders.map((folder) => {
    const items = byFolder.get(folder).slice();
    items.sort((a, b) => (b.deleted_at ?? 0) - (a.deleted_at ?? 0));
    return { folder, items };
  });
}

export function selectionBytes(selection, items) {
  if (!selection || selection.size === 0) return 0;
  let total = 0;
  for (const it of items) {
    if (selection.has(it.path)) total += it.size ?? 0;
  }
  return total;
}

export function formatBytes(n) {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}

export function urgentClass(daysRemaining) {
  return daysRemaining <= 7 ? 'is-urgent' : '';
}

export function authorClass(deletedBy) {
  if (deletedBy == null) return 'is-system';
  if (/^(claude|agent|bot)/i.test(deletedBy)) return 'is-agent';
  if (deletedBy.includes('-agent-')) return 'is-agent';
  return 'is-user';
}

export function splitFolderName(folder) {
  if (!folder) return { lead: '', tail: '' };
  const i = folder.lastIndexOf('/');
  if (i < 0) return { lead: '', tail: folder };
  return { lead: folder.slice(0, i), tail: folder.slice(i + 1) };
}

// TODO: align with recent-groups.js formatRelativeTime after B8 ships
// (B8 plan defines a sibling helper; collapse to a single shared
// implementation in a follow-up).
export function formatRelative(ms, now) {
  if (ms == null) return '';
  const delta = now - ms;
  if (delta < MINUTE) return 'just now';
  if (delta < HOUR) return `${Math.floor(delta / MINUTE)}m ago`;
  if (delta < DAY) return `${Math.floor(delta / HOUR)}h ago`;
  if (delta < WEEK) return `${Math.floor(delta / DAY)}d ago`;
  const d = new Date(ms);
  return `${MONTHS[d.getMonth()]} ${d.getDate()}`;
}
